import { render, staticRenderFns } from "./rTabs.vue?vue&type=template&id=4d209bea&"
import script from "./rTabs.vue?vue&type=script&lang=js&"
export * from "./rTabs.vue?vue&type=script&lang=js&"
import style0 from "./rTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports